import { Eye, X, ChevronRight } from "lucide-react";
import { useAuth, PREVIEW_PRESETS } from "../../store/AuthContext";

// Owner-only bar shown while "viewing as a customer"; lets the owner switch plan scenarios or exit.
export const PreviewBar = () => {
  const { previewAs, setPreviewAs, nextPreview } = useAuth();
  if (!previewAs) return null;
  return (
    <div className="relative z-[60] flex items-center gap-3 border-b border-[#f0c945]/40 bg-[#1a1a0f] px-3 py-1 text-[12px] text-[#e8e9ec]" data-testid="preview-bar">
      <Eye className="h-4 w-4 text-[#f0c945]" />
      <span className="font-medium text-[#f0c945]">Customer preview</span>
      <span className="text-[#9aa0a8]">Exactly what a customer sees. Screen:</span>
      <select data-testid="preview-scenario-select" style={{ marginLeft: 0 }} value={previewAs} onChange={(e) => setPreviewAs(e.target.value)} className="field h-6 w-auto py-0 text-[12px]">
        {Object.entries(PREVIEW_PRESETS).map(([k, p]) => <option key={k} value={k}>{p.label}</option>)}
      </select>
      <button data-testid="preview-next-btn" onClick={nextPreview} className="flex items-center gap-1 rounded-md border border-[#27324a] px-2 py-0.5 text-[#e8e9ec] hover:bg-[#27324a]/50">Next screen <ChevronRight className="h-3.5 w-3.5" /></button>
      <button data-testid="preview-exit-btn" onClick={() => setPreviewAs(null)} className="flex items-center gap-1 rounded-md border border-[#f0c945]/50 px-2 py-0.5 text-[#f0c945] hover:bg-[#f0c945]/20"><X className="h-3.5 w-3.5" /> Back to Owner view</button>
    </div>
  );
};
